<script>
import Layout from '@layouts/main.vue'
import InvoicesList from '@components/invoices/invoices-list.vue'
import InvoiceFilePreview from '@components/invoices/invoice-file-preview.vue'

export default {
  name: 'FinanceView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Finance page.' }],
    }
  },
  components: { Layout, InvoicesList, InvoiceFilePreview },
  data() {
    return {
      showDownloadDialog: false,
      invoice: {},
    }
  },
  methods: {
    downloadInvoice(invoice) {
      this.showDownloadDialog = true
      this.invoice = invoice
    },
  },
}
</script>

<template>
  <Layout>
    <!-- TODO: Unhide actions when we include filter invoices query by clients filter -->
    <BasePageHeader :title="$t('finance.financePageTitle')" hide-actions />
    <InvoicesList @downloadInvoice="downloadInvoice" />
    <InvoiceFilePreview :show.sync="showDownloadDialog" :invoice="invoice" />
  </Layout>
</template>
